export const isAbortSignal = value => value != null && value instanceof AbortSignal;

export const anyOf = (...signals) => {
	const filteredSignals = signals.filter(isAbortSignal);

	const controller = new AbortController();

	const abort = event => {
		filteredSignals.forEach(signal => signal.removeEventListener("abort", abort));
		filteredSignals.splice(0, filteredSignals.length);
		controller.abort(event);
	};

	filteredSignals.forEach(signal => signal.addEventListener("abort", abort));

	return controller.signal;
};

export const allOf = (...signals) => {
	const filteredSignals = signals.filter(isAbortSignal);
	const controller = new AbortController();
	const aborted = new Set();

	const abort = event => {
		aborted.add(event.currentTarget);
		event.currentTarget.removeEventListener("abort", abort);

		if (aborted.size < filteredSignals.length) return;

		aborted.clear();
		filteredSignals.splice(0, filteredSignals.length);
		controller.abort(
			new Event("abort", {
				bubbles: false,
				cancelable: false,
				composed: true,
			}),
		);
	};

	filteredSignals.forEach(signal => signal.addEventListener("abort", abort));

	return controller.signal;
};
